import { render, staticRenderFns } from "./EditDomainWhitelist.vue?vue&type=template&id=6cfd2944&scoped=true&"
import script from "./EditDomainWhitelist.vue?vue&type=script&lang=ts&"
export * from "./EditDomainWhitelist.vue?vue&type=script&lang=ts&"
import style0 from "./EditDomainWhitelist.vue?vue&type=style&index=0&id=6cfd2944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd2944",
  null
  
)

export default component.exports